module.exports = __webpack_public_path__ + "static/img/pos.6eeed5b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pos.jpg
// module id = 84Xe
// module chunks = 1